import { Box, styled } from '@material-ui/core';
import { SText, SInput } from '@setvi/shared/components';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '360px',
  padding: theme.spacing(1, 3)
}));

const Form = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0)
}));

interface PreparedForStepProps {
  data: {
    companyName: string;
    address: string;
    phoneNumber: string;
  };
  onChange: (data: any) => void;
}

export const PreparedForStep = ({ data, onChange }: PreparedForStepProps) => {
  const handleChange = (field: string, value: string) => {
    // Validate phone number to only allow digits, +, and -
    if (field === 'phoneNumber') {
      const validPhonePattern = /^[\d+-]*$/;
      if (!validPhonePattern.test(value)) {
        return;
      }
    }

    onChange({
      ...data,
      [field]: value
    });
  };

  return (
    <Container>
      <SText size="lg" weight="bold">
        Prepared for
      </SText>

      <Form>
        <SInput
          fullWidth
          newDesign
          label="Company name"
          required
          value={data.companyName}
          placeholder="Enter company name"
          onChange={e => handleChange('companyName', e.target.value)}
        />

        <SInput
          newDesign
          fullWidth
          label="Address"
          required
          value={data.address}
          placeholder="Enter address"
          onChange={e => handleChange('address', e.target.value)}
        />

        <SInput
          fullWidth
          newDesign
          label="Phone number"
          required
          value={data.phoneNumber}
          placeholder="Enter phone number"
          onChange={e => handleChange('phoneNumber', e.target.value)}
        />
      </Form>
    </Container>
  );
};
